import { Dialog } from 'vant';
const showNoneMonitor = () => {
  Dialog.confirm({
    title: '温馨提示',
    message: '你的监控名额已用完，升级会员等级，最高可增加至100个监控名额',
    confirmButtonText: '去升级',
    cancelButtonText: '知道了'
  }).then(() => {
    window.location.href = '/dredgeVip?unSelect=0,2'
  }).catch(() => {
    // on cancel
  });
}

export default showNoneMonitor
